/**
 * Footer component that loads from the current theme.
 */
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useSettings } from '../contexts/SettingsContext';

export const Footer: React.FC = () => {
  const { currentTheme } = useTheme();
  const { settings } = useSettings();
  const appName = settings?.app_name || 'dasher';
  
  // Safety check: if currentTheme is undefined, render default footer
  if (!currentTheme) {
    return (
      <footer className="default-footer">
        <div className="footer-content">
          <p className="footer-text">© {new Date().getFullYear()} {appName}</p>
        </div>
      </footer>
    );
  }
  
  // If theme has a footer component, render it
  if (currentTheme.footer) {
    const FooterComponent = currentTheme.footer;
    return <FooterComponent />;
  }
  
  // Default footer if theme doesn't provide one
  return (
    <footer className="default-footer">
      <div className="footer-content">
        <p className="footer-text">© {new Date().getFullYear()} {appName}</p>
      </div>
    </footer>
  );
};

